/* eslint-disable react/forbid-foreign-prop-types */
import LayoutProps from 'admin-components/proptypes/groups/layout';

export const propTypes = {
  ...LayoutProps.propTypes
};

export const defaultProps = {
  ...LayoutProps.defaultProps,
  width: 12
};

export const propDescriptions = {
  ...LayoutProps.propDescriptions
};
